import { styled } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)(() => ({
  color: "inherit",
  textDecoration: "none",
}));

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    blue: {
      color: theme.primary500,
      fontSize: 14,
      marginTop: theme.spacing(10),
    },
    blueSmall: {
      color: theme.primary500,
      fontSize: 12,
    },
    withHover: {
      "&:hover": {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
  }),
);
type Props = {
  children: React.ReactNode;
  className?: string;
  to: string | object;
  blue?: boolean;
  blueSmall?: boolean;
  withHover?: boolean;
  target?: string;
  "data-test-id"?: string;
};
export function LinkItem({
  blue,
  blueSmall,
  children,
  className = "",
  to,
  withHover,
  target,
  "data-test-id": dataTestId,
}: Props) {
  const classes = useStyles();

  return (
    <StyledLink
      className={`${blue ? classes.blue : ""} ${
        withHover ? classes.withHover : ""
      } ${blueSmall ? classes.blueSmall : ""} ${className}`}
      to={to}
      target={target || (typeof to === "string" ? "_self" : "_blank")}
      data-test-id={dataTestId}
    >
      {children}
    </StyledLink>
  );
}
